export enum HospitalizationType {
  urgency = 'Urgência',
  elective = 'Eletivo'
}

export const hospitalizationList = [
  {
    label: HospitalizationType.elective,
    value: 'elective'
  },
  {
    label: HospitalizationType.urgency,
    value: 'urgency'
  }
]
